<template>
  <div class="productCard container pt-0" v-if="browserSize === `mobile`">
    <v-card
      elevation="2"
      style="height: 100%; font-size: 13px"
      class="my-element px-4 py-3"
    >
      <v-row class="">
        <v-col cols="12">
          <Etiquette :status="parseInt(theOrder.status)"></Etiquette>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="my-title-3 pb-0" cols="6">
          <div>شماره فاکتور:</div>
          <div class="pb-2">
            {{ theOrder.id }}
          </div>
        </v-col>
        <v-col v-if="theOrder.seller_image" class="pb-0" cols="6">
          <div class="image-wrapper-last text-left">
            <img :src="theOrder.seller_image[0]" />
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-0">
        <v-col v-if="theOrder.user_name" class=" pb-0" cols="6">
          <div>نام کاربر:</div>
          <div class="pb-2 my-title-3">
            {{ theOrder.user_name }}
          </div>
        </v-col>
        <v-col v-if="!theOrder.user_name" class="my-title-3 pb-0" cols="6">
          <div class="pb-2">ناشناس</div>
        </v-col>
      </v-row>

      <v-row class="mt-0 normal text-color">
        <v-col>
          <div v-if="theOrder.user_mobile" class="mb-1">
            <div class="mb-1 normal text-color">شماره موبایل:</div>
            <div class="normal text-color">
              {{ theOrder.user_mobile }}
            </div>
          </div>
          <div class="mb-1">
            <span class="ml-1">زمان سفارش:</span>
            <span> {{ theOrder.time }}</span>
          </div>
          <div class="mb-1">
            مبلغ پرداخت :
            <span class="my-title-3"> {{ separator_number( theOrder.payable) }} تومان</span>
          </div>
          <div>
            هزینه ارسال:
            {{ separator_number(theOrder.delivery_cost) }} تومان
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-2 normal text-color">
        <v-col cols="12">
          <div class="normal text-color mb-1">آدرس:</div>
          <div>
            {{ theOrder.address }}
          </div>
        </v-col>
      </v-row>
      <div v-if="6 < theOrder.status >= 1" class="mb-2">تعیین وضعیت:</div>
      <div v-if="theOrder.status == 1" class="mb-2 text-center">
        <v-btn @click="this_status(2)" class="ml-2" color="success">قبول</v-btn>
        <v-btn @click="this_status(3)" color="pink darken-1 white--text"
          >لغو</v-btn
        >
      </div>

      <div v-if="theOrder.status == 2" class="mb-2 text-center">
        <v-btn
          @click="this_status(4)"
          class="ml-2"
          color="light-blue lighten-3  white--text"
          >در حال آماده سازی</v-btn
        >
      </div>
      <div v-if="theOrder.status == 4" class="mb-2 text-center">
        <div v-if="!theOrder.seller_image">
          <div v-if="!image_choose" class="my-alarm _2 mb-1">
            لطفا عکس محصول را بارگذاری کنید:
          </div>
          <div v-if="product_image.url" class="image-wrapper">
            <img :src="product_image.url" alt="" />
          </div>
          <v-btn
            outlined
            color="#2196F3"
            class="my-center mb-2"
            @click="click_to_up_image"
            >بارگذاری</v-btn
          >
          <v-btn
            v-if="image_choose"
            outlined
            color="#2196F3"
            class="my-center mb-2"
            @click="submit_image"
            >ثبت عکس</v-btn
          >
          <input
            type="file"
            id="getImage"
            class="d-none"
            @change="(e) => add_new_image(e)"
            accept="image/*"
          />
        </div>
        <v-btn
          v-if="image_uploaded || theOrder.seller_image"
          @click="this_status(5)"
          class="ml-2"
          color="light-blue darken-4 white--text"
          >در حال ارسال</v-btn
        >
      </div>
      <div v-if="theOrder.status == 5" class="mb-2 text-center">
        <v-btn
          @click="this_status(6)"
          class="my-center"
          color="teal accent-3 white--text"
          >تحویل داده شد</v-btn
        >
      </div>
      <div class="text-center">
        <button @click="details()" class="my-button-2 this py-2">جزئیات</button>
      </div>
    </v-card>
    <v-dialog v-model="dialog" width="98%">
      <v-card v-if="confirm_on">
        <div class="p-3 text-center">
          <div>آیا از انجام این عملیات</div>
          <!-- <div>فیلان</div> -->
          <div class="mb-2">مطمئن هستید؟</div>
          <v-card-actions>
            <button class="its_ok ml-2" @click="reviseOrder()">
              بله، مطمئنم!
            </button>
            <button class="its_not" @click="dialog = false">خیر</button>
          </v-card-actions>
        </div>
      </v-card>
      <v-card v-if="details_on">
        <DetailsOrder :order="theOrder" />
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      عکس ثبت شد
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          باشه
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Etiquette from "./etiquette";
import CustomInput from "../../../Common/CustomInput";
import jalalim from "jalali-moment";
import Service from "../../../../utils/seller-service";
import DetailsOrder from "./DetailsOrder.vue";
import SeparatorNumber from "../../../../utils/MyTools";

export default {
  name: "OrderSummaryMobileView",
  props: ["theOrder", "browserSize"],
  components: {
    Etiquette,
    CustomInput,
    DetailsOrder,
  },
  data: () => ({
    status: { value: null, valid: true },
    stati: [
      { value: 1, text: "پرداخت شده" },
      { value: 2, text: "قبول شده" },
      { value: 3, text: "رد شده" },
      { value: 4, text: "در حال آماده سازی" },
      { value: 5, text: "در حال ارسال" },
      { value: 6, text: "تحویل داده شده" },
    ],
    dialog: false,
    image_choose: false,
    image_uploaded: false,
    product_image: {},
    snackbar: false,
    details_on: false,
    confirm_on: false,
    order_info: {
      id: null,
      status: null,
    },
  }),
  methods: {
    separator_number : function (number) {
      return SeparatorNumber(number);
    },
    reviseOrder: function () {
      this.dialog = false;
      this.order_info.id = this.theOrder.id;
      this.$emit("reviseOrder", this.order_info);
    },
    details() {
      this.dialog = true;
      this.details_on = true;
      this.confirm_on = false;
    },
    this_status(my_status) {
      this.order_info.status = my_status;
      console.log(this.order_info);
      this.dialog = true;
      this.confirm_on = true;
      this.details_on = false;
    },
    add_new_image(e) {
      this.product_image = {
        image: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0]),
      };
      this.image_choose = true;
    },
    click_to_up_image() {
      document.getElementById("getImage").click();
      // this.add_new_image();
    },
    submit_image() {
      const form_data = new FormData();
      form_data.append("image[0]", this.product_image.image);
      this.authService.transmit(
        "seller/order/image/add/" + this.theOrder.id,
        form_data,
        (s, d) => {
          if (s == 200) {
            this.image_uploaded = true;
            console.log("image uploaded");
          }
        },
        (s, e) => {
          console.log("this is error", e);
        }
      );
    },
  },
  computed: {
    theDate: function () {
      return jalalim(this.theOrder.pay_time).locale("fa").format("YY/MM/DD");
    },
    authService: function () {
      return Service(true);
    },
    
  },
};
</script>

<style lang="scss" scoped>
.item-picture {
  width: 100%;
}
.productCard {
  background-color: rgb(252 252 252);
}
.actionIcon {
  width: 20px;
  height: 20px;
  margin-top: 20px;
}
.proCol {
  align-self: center;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
.my-element {
  border-radius: 15px;
}
.its_ok {
  color: white;
  background: rgb(57, 147, 221);
  border-radius: 15px;
  width: 50%;
  padding: 10px;
  margin: 0 auto;
}
.its_not {
  color: white;
  background: rgb(221, 57, 57);
  border-radius: 15px;
  width: 50%;
  padding: 10px;
  margin: 0 auto;
}
.my-button-2.this {
  border-radius: 20px;
}
.image-wrapper {
  padding: 10px;
  img {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    display: block;
    border-radius: 10px;
  }
}
.image-wrapper-last {
  img {
    width: 60px;
    height: 60px;
    border-radius: 10px;
  }
}
.details {
  border-radius: 15px;
}
</style>